<footer>
  <div class="p-d-flex p-jc-between footer-responsive">
    <div class="info p-d-flex footer-font">
      <div class="info-prawa">
        &copy;
        2021 Wszystkie prawa zastrzeżone
      </div>
      <div class="p-d-flex p-ml-3 split-line">
        <div class="p-ml-3">
          <span>Data wydania: {{data}}</span>
        </div>
      </div>
      <div class="p-d-flex p-ml-3 split-line">
        <div class="p-ml-4">
          <span>Wersja: {{version}}</span>
        </div>
      </div>
    </div>
    <div class="fe-ue">
      <img class="fundusze" src="./assets/images/fundusze-footer.png">
      <img class="rzeczpospolita" src="./assets/images/rzeczpospolita-footer.png">
      <img class="unia" src="./assets/images/unia-footer.png">
      <div class="p-ml-3 p-pl-3 split-line">
        <img class="logo-ms" src="./assets/images/logo-ms.png" alt="Logo Ministerstwa Sprawiedliwości">
      </div>
    </div>
  </div>
</footer>
